import { ListItemIcon } from "@mui/material";
import React from "react";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import WorkspacesIcon from "@mui/icons-material/Workspaces";
import MedicalInformationIcon from "@mui/icons-material/MedicalInformation";
import PriceChangeIcon from "@mui/icons-material/PriceChange";
import VaccinesIcon from "@mui/icons-material/Vaccines";
import DashboardIcon from "@mui/icons-material/Dashboard";
import SettingsIcon from "@mui/icons-material/Settings";
import styles from "./sidebar.module.scss";
import ClientPortalPage from "../../common/enums/client-portal-page";

const getIcon = (name: string): React.JSX.Element => {
  switch (name) {
    case ClientPortalPage.DASHBOARD:
      return <DashboardIcon />;
    case ClientPortalPage.APPOINTMENTS:
      return <CalendarMonthIcon />;
    case ClientPortalPage.BRANCHES:
      return <WorkspacesIcon />;
    case ClientPortalPage.MEDICAL_RECORDS:
      return <MedicalInformationIcon />;
    case ClientPortalPage.BILLING:
      return <PriceChangeIcon />;
    case ClientPortalPage.SETTINGS:
      return <SettingsIcon />;
    case ClientPortalPage.LAB:
      return <VaccinesIcon />;
    default:
      return <DashboardIcon />;
  }
};

const SidebarIcon = ({ name }: { name: string }): React.JSX.Element => (
  <ListItemIcon className={styles.listItemButtonIcon}>{getIcon(name)}</ListItemIcon>
);

export default SidebarIcon;
